export default {
  'APP_JOB_UPDATE': 'APP_JOB_UPDATE',
  "APP_THRESHOLD_RULE_UPDATE": "APP_THRESHOLD_RULE_UPDATE",
}